import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { ISharedVersionInfo } from '../../ts/models/ISharedVersionInfo';
import { GetShareActivityRequest, IGetShareActivityResult } from '../../ts/ServerApi/requests/GetShareActivityRequest';

class ShareActivityService {

  private getSharedVersionInfo = new WebClientListResourceFetcher(GetShareActivityRequest, ServerApiMapper.shareActivity);

  public getShareActivity(viewId: string): Promise<ISharedVersionInfo[]> {
    return WebHttpClient.sendRequest(new GetShareActivityRequest({
      viewId
    })).then((result: IGetShareActivityResult) => {
      return ServerApiMapper.shareActivity(result);
    });
  }
}

export const ShareActivity = new ShareActivityService();
